import header_logo from '../../Assets/utility-safety-partners.svg'
import './Header.scss';
import { useState } from 'react';
import Button from '../../Utils/Button'
import DateSelector from '../DateSelector/DateSelector'

function Header(props) {
	const [value, setValue] = useState('test');
	


	function toggleFilterObject(key){		
		let object = props.activeFilters;
		
		object[key] = !object[key];
		
		return object;
	}
	return (
    	<div className="Header flex flex-col sm:flex-row items-center justify-center bg-gray1">
			<div className="container flex flex-row justify-between mx-auto px-4 ">
				<div>
					<a href="https://utilitysafety.ca/">
						<img className='header-logo' src={header_logo} alt="" />
					</a>
				</div>
				<div className="nav h-100 flex flex-col justify-between text-right">
					<div>
						<DateSelector setActiveDate={(date) => {props.setActiveDate(date)}} possibleYears={props.possibleYears}></DateSelector>
					</div>
					<div className="flex filters-nav hidden sm:flex">
						<Button onClick={() => {props.setActiveFilters({
							underground:props.activeFilters.underground,
							overhead:!props.activeFilters.overhead,
							locate_requested:props.activeFilters.locate_requested,
						})}} type="overhead" open={props.activeFilters.overhead}>Above Ground</Button>
						<Button onClick={() => {props.setActiveFilters({
							underground:!props.activeFilters.underground,
							overhead:props.activeFilters.overhead,
							locate_requested:props.activeFilters.locate_requested,
						})}} type="underground" open={props.activeFilters.underground}>Below Ground</Button>
						<Button onClick={() => {props.setActiveFilters({
							underground:props.activeFilters.underground,
							overhead:props.activeFilters.overhead,
							locate_requested:!props.activeFilters.locate_requested,
						})}} type="locate_requested" open={props.activeFilters.locate_requested}>Locate Requested</Button>
					</div>
				</div>				
			</div>
			<div className="flex filters-nav flex sm:hidden pt-5">
				<Button onClick={() => {props.setActiveFilters({
					underground:props.activeFilters.underground,
					overhead:!props.activeFilters.overhead,
					locate_requested:props.activeFilters.locate_requested,
				})}} type="overhead" open={props.activeFilters.overhead}>Above Ground</Button>
				<Button onClick={() => {props.setActiveFilters({
					underground:!props.activeFilters.underground,
					overhead:props.activeFilters.overhead,
					locate_requested:props.activeFilters.locate_requested,
				})}} type="underground" open={props.activeFilters.underground}>Below Ground</Button>
				<Button onClick={() => {props.setActiveFilters({
					underground:props.activeFilters.underground,
					overhead:props.activeFilters.overhead,
					locate_requested:!props.activeFilters.locate_requested,
				})}} type="locate_requested" open={props.activeFilters.locate_requested}>Locate Requested</Button>
			</div>
		</div>
	);
}

export default Header;
